export default class UniqueIngredientName {
  constructor($q, UserIngredientsService) {
    'ngInject';

    Object.assign(this, {
      $q,
      UserIngredientsService
    });

    this.require = 'ngModel';
    this.restrict = 'A';
  }

  link($scope, element, attrs, ctrl) {
    let ingredientId = null;

    if (attrs.ingredientId) {
      ingredientId = attrs.ingredientId;
    }

    // Async validator requires resolve or reject to set validity
    ctrl.$asyncValidators.uniqueUserIngredientName = (ingredientName) => {
      const defer = this.$q.defer();

      this.UserIngredientsService.isUniqueIngredientName(ingredientName, ingredientId)
        .then((r) => {
          if (r.data) {
            defer.resolve();
          }

          defer.reject();
        }).catch(() => defer.reject());

      return defer.promise;
    };
  }

  static directiveFactory($q, UserIngredientsService) {
    'ngInject';

    return new UniqueIngredientName($q, UserIngredientsService);
  }
}



// WEBPACK FOOTER //
// ./common/directives/validation/unique-ingredient-name.js